import React from "react";

export default function Menu({ userType }) {
  const isSmall = userType === 1;
  const cols = [
    { cls: "menuUsername", text: "Super" },
    { cls: "menuUsername", text: "Booked" },
    { cls: "menuUsername", text: "Live P&L" },
    { cls: "menuUsername", text: "Net P&L" },
    { cls: "menuName", text: "Admin Sharing" },
    { cls: "menuName", text: "Super Sharing" },
    { cls: "menuName", text: "Admin Live P&L" },
    { cls: "menuName", text: "Super Live P&L" },
  ];

  return (
    <div className="menuContainer primary white">
      {cols.map((c) => (
        <div key={c.text} className={`${c.cls} ${isSmall ? "small" : ""}`}>
          {c.text}
        </div>
      ))}
    </div>
  );
}
